import RESTFUL_axios  from '@/api/restful_axois';
import apiError       from '@/api/apierror';

const RESTFUL_fn = (apiType, reqData) => {
  var apiName = 'addfriend';
  var reqName = apiName+'_'+apiType;
  var apiConfigs = {
    _get: {
      url: '/saasajax/user.ajax.php?action=getUserInfoByQrCodeIn',
      data: function () {
        return {
          sq: reqData.sourceHash,
          timeStamp: Math.floor(reqData.timeStamp / 1000),
          signKey: window.md5(Math.floor(reqData.timeStamp / 1000) + 'classin'),
        };
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
            {
              let resData = res.data;
              if (resData) {
                let avatar = ''
                if (resData.avatar_url) {
                  let avatarObj = JSON.parse(resData.avatar_url)
                  avatar = `/${avatarObj.Path}/${avatarObj.Spic}`
                }
                return {
                  avatar: avatar,
                  nickName: resData.nickname,
                  telephone: resData.telephone
                }
              }
              break;
            }
          case 10003:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_'+apiType].url,
              req: reqData,
              res: res
            })
        }
      }
    }
  }
  return RESTFUL_axios({
    reqName:reqName,
    reqConfig:apiConfigs['_'+apiType],
    reqData:reqData,
  });
}
export default RESTFUL_fn
